// extracted by mini-css-extract-plugin
module.exports = {"field":"_2QpOf0CSuuB8zxdr5peZOH","label":"_3aGspQucBudSHdINNCj_tj"};